import { Swiper } from 'swiper';
import { A11y, Navigation, Pagination } from 'swiper/modules';

const sliders = document.querySelectorAll('.block-card-slider .swiper');

sliders.forEach((slider) => {
	const settings = {
		loop: false,
		grabCursor: true,
		spaceBetween: 16,
		slidesPerView: 1,
		autoHeight: true,
		modules: [A11y, Navigation, Pagination],
		a11y: {
			itemRoleDescriptionMessage: 'slide',
		},
		navigation: {
			prevEl: slider.parentElement.querySelector('.swiper-button-prev'),
			nextEl: slider.parentElement.querySelector('.swiper-button-next'),
		},
		pagination: {
			el: slider.parentElement.querySelector('.swiper-pagination'),
			clickable: true,
		},
		breakpoints: {
			772: {
				autoHeight: false,
			},
		},
	};

	new Swiper(slider, settings);
});
